import repository from '@/utils/repository';

const common_resource = '/move';

export default {
    searchBankBranchInfo: (data) => {
        return repository.post(`${common_resource}/postCommonMst013Info`, {
            ...data
        });
    }
};
